import * as React from 'react'
import Notifications from 'react-notification-system-redux'

export default class NotificationsWrapper extends React.PureComponent<
  Notifications.NotificationsProps,
  {}
> {
  public render() {
    const style: any = {
      Containers: {
        tr: {
          top: '56px',
        },
      },
      MessageWrapper: {
        DefaultStyle: {
          whiteSpace: 'pre-wrap',
        },
      },
    }

    return (
      <Notifications
        notifications={this.props.notifications ?? []}
        style={style}
      />
    )
  }
}
